import React from 'react';
import { useNavigate } from 'react-router';
import BackLink from 'web/components/BackLink';
import ColumnContainer from 'web/components/ColumnContainer';
import Meta from 'web/components/Meta';
import ServiceCreateImpl from 'web/components/Services/ServiceCreate';
import WithHeaderContentColumn from 'web/components/WithHeaderContentColumn';

const ServiceCreate = () => {
  const navigate = useNavigate();

  return (
    <>
      <Meta title="Create a new service" />
      <BackLink to="/dashboard/scheduling" />
      <ColumnContainer>
        <WithHeaderContentColumn header="Create a new service" whiteBackground>
          <ServiceCreateImpl
            withWorkflows
            withLocation
            withAvailability
            onSuccess={() => navigate('/dashboard/scheduling', { replace: true })}
          />
        </WithHeaderContentColumn>
        <div />
      </ColumnContainer>
    </>
  );
};

export default ServiceCreate;
